import { render, staticRenderFns } from "./OrganizationSelectBox.vue?vue&type=template&id=778a808e&scoped=true&"
import script from "./OrganizationSelectBox.vue?vue&type=script&lang=js&"
export * from "./OrganizationSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778a808e",
  null
  
)

export default component.exports